<div class="container">
  <app-page-header
    title="Vinculador Pagador PM"
    subtitle="Al enviar el formulario se iniciara el proceso de extraccion de datos e inicio de proceso de vinculacion en PM. Recibira en un correo el link para acceder al proceso en PM."
    icon="shield">
  </app-page-header>

  <div class="form-alert form-alert--error" *ngIf="showAlertError">
    <i class="form-alert-icon">⚠</i>
    <span>{{ errorMessage }}</span>
  </div>
  <div class="form-alert form-alert--success" *ngIf="showAlertSuccess">
    <i class="form-alert-icon">✓</i>
    <span>{{ successMessage }}</span>
  </div>

  <section class="vinculador-section">
    <div class="form-container">
      <div class="form-wrapper">
        <div class="form-content">
          <div class="upload-grid">
            <div class="upload-card">
              <label class="form-label form-label--required">Camara de comercio</label>
              <div
                class="upload-dropzone"
                [class.dragging]="camaraDragging"
                [class.has-file]="camaraFile"
                (dragover)="onDragOver($event, 'camara')"
                (dragleave)="onDragLeave($event, 'camara')"
                (drop)="onDrop($event, 'camara')"
                (click)="triggerFileInput('camara')"
                (keydown.enter)="triggerFileInput('camara')"
                (keydown.space)="triggerFileInput('camara')"
                tabindex="0"
                role="button"
                [attr.aria-label]="camaraFile ? 'Archivo seleccionado: ' + camaraFile.name : 'Haz clic o arrastra el PDF de camara de comercio'">
                <input
                  #camaraInput
                  type="file"
                  accept="application/pdf,.pdf"
                  class="upload-input-hidden"
                  (change)="onFileSelected($event, 'camara')" />

                <div class="upload-dropzone-content">
                  <svg *ngIf="!camaraFile" class="upload-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                  </svg>
                  <svg *ngIf="camaraFile" class="file-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>

                  <div class="upload-text">
                    <p class="upload-title" *ngIf="!camaraFile">Arrastra el PDF aqui</p>
                    <p class="upload-title success" *ngIf="camaraFile">{{ camaraFile.name }}</p>
                    <p class="upload-subtitle" *ngIf="!camaraFile">o haz clic para seleccionar</p>
                    <p class="upload-subtitle" *ngIf="camaraFile">{{ formatFileSize(camaraFile) }}</p>
                  </div>
                </div>
              </div>
              <button type="button" class="upload-clear" *ngIf="camaraFile" (click)="clearFile('camara')">
                Limpiar
              </button>
            </div>

            <div class="upload-card">
              <label class="form-label form-label--required">Estados financieros</label>
              <div
                class="upload-dropzone"
                [class.dragging]="estadosDragging"
                [class.has-file]="estadosFile"
                (dragover)="onDragOver($event, 'estados')"
                (dragleave)="onDragLeave($event, 'estados')"
                (drop)="onDrop($event, 'estados')"
                (click)="triggerFileInput('estados')"
                (keydown.enter)="triggerFileInput('estados')"
                (keydown.space)="triggerFileInput('estados')"
                tabindex="0"
                role="button"
                [attr.aria-label]="estadosFile ? 'Archivo seleccionado: ' + estadosFile.name : 'Haz clic o arrastra el PDF de estados financieros'">
                <input
                  #estadosInput
                  type="file"
                  accept="application/pdf,.pdf"
                  class="upload-input-hidden"
                  (change)="onFileSelected($event, 'estados')" />

                <div class="upload-dropzone-content">
                  <svg *ngIf="!estadosFile" class="upload-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                  </svg>
                  <svg *ngIf="estadosFile" class="file-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>

                  <div class="upload-text">
                    <p class="upload-title" *ngIf="!estadosFile">Arrastra el PDF aqui</p>
                    <p class="upload-title success" *ngIf="estadosFile">{{ estadosFile.name }}</p>
                    <p class="upload-subtitle" *ngIf="!estadosFile">o haz clic para seleccionar</p>
                    <p class="upload-subtitle" *ngIf="estadosFile">{{ formatFileSize(estadosFile) }}</p>
                  </div>
                </div>
              </div>
              <button type="button" class="upload-clear" *ngIf="estadosFile" (click)="clearFile('estados')">
                Limpiar
              </button>
            </div>
          </div>

          <div class="form-actions form-actions--center">
            <button
              type="button"
              class="form-btn form-btn--cancel"
              (click)="clearAll()"
              [disabled]="isSubmitting">
              Limpiar
            </button>
            <button
              type="button"
              class="form-btn form-btn--submit"
              (click)="submit()"
              [ngClass]="{ 'is-valid': canSubmit, 'is-loading': isSubmitting }"
              [disabled]="!canSubmit">
              <span *ngIf="!isSubmitting">Enviar documentos</span>
              <span *ngIf="isSubmitting" class="form-spinner"></span>
            </button>
          </div>

        </div>
      </div>
    </div>
  </section>
</div>
